import { actionTypes } from "./constants";
const initialState = {
  quotationReleaseList:{
    list: [],
    count: 0,
  },
  quotationReleaseDetail: {},
  quotationRelHistory: [],
  docReleaseList: {
    list: [],
    count: 0,
  },
  docReleaseHistory: [],
  faqReleaseList: {
    list: [],
    count: 0,
  }
};

export default function reducer(state = initialState, action) {
  switch (action.type) {
    case actionTypes.SET_QUOTATION_RELEASE_LIST:
      return {
        ...state, quotationReleaseList: action.data,
      };
    case actionTypes.SET_QUOTATION_RELEASE_HISTORY_LIST:
      return {
        ...state, quotationRelHistory: action.data,
      };
    case actionTypes.SET_QUOTATION_RELEASE_DETAIL:
      return {
        ...state, quotationReleaseDetail: action.data,
      };
    case actionTypes.SET_DOC_RELEASE_LIST:
      return {
        ...state, docReleaseList: action.data,
      };
    case actionTypes.SET_DOC_RELEASE_HISTORY_LIST:
      return {
        ...state, docReleaseHistory: action.data,
      };
    case actionTypes.SET_FAQ_RELEASE_LIST:
      return {
        ...state, faqReleaseList: action.data,
      };
    default:
      return state;
  }
};